<template>
  <v-dialog v-model="visible" max-width="700px" persistent>
    <v-card>
      <v-toolbar flat color="secondary" dark>
        <v-toolbar-title>
          <v-icon left>mdi-bell-outline</v-icon>
          Notificaciones de {{ user?.name || 'Usuario' }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-alert type="info" dense text>
          Administra las notificaciones que este usuario recibe o puede ver.
        </v-alert>

        <v-skeleton-loader v-if="loading" type="list-item" class="mt-4" />
        <v-simple-table v-else>
          <thead>
            <tr>
              <th>Título</th>
              <th>Tipo</th>
              <th>Activo</th>
              <th class="text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="notif in notifications" :key="notif.id">
              <td>{{ notif.title }}</td>
              <td>{{ notif.type }}</td>
              <td>
                <v-switch v-model="notif.isActive" hide-details dense></v-switch>
              </td>
              <td class="text-center">
                <v-btn icon small @click="editNotification(notif)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon small color="error" @click="deleteNotification(notif.id)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <v-btn
          color="secondary"
          class="mt-4"
          block
          @click="addNotification"
        >
          <v-icon left>mdi-plus</v-icon>
          Agregar notificación
        </v-btn>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('close')">Cerrar</v-btn>
        <v-btn color="primary" @click="saveNotifications" :loading="saving">
          Guardar cambios
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'UserNotificationsDialog',
  props: {
    user: { type: Object, required: true },
    value: { type: Boolean, default: true }
  },
  data: () => ({
    visible: true,
    loading: true,
    saving: false,
    notifications: []
  }),
  watch: {
    value (val) { this.visible = val },
    visible (val) { if (!val) this.$emit('close') }
  },
  mounted () {
    this.loadNotifications()
  },
  methods: {
    async loadNotifications () {
      try {
        this.loading = true
        const { data } = await this.$axios.get(`/api/users/${this.user.id}/notifications`)
        this.notifications = data || []
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    addNotification () {
      this.notifications.push({ title: '', type: 'Custom', isActive: true, new: true })
    },
    editNotification (notif) {
      // podrías abrir un modal más detallado si lo necesitas
      notif.editing = !notif.editing
    },
    async deleteNotification (id) {
      this.notifications = this.notifications.filter(n => n.id !== id)
    },
    async saveNotifications () {
      try {
        this.saving = true
        await this.$axios.put(`/api/users/${this.user.id}/notifications`, {
          notifications: this.notifications
        })
        this.$toast.success('Notificaciones actualizadas correctamente')
        this.$emit('close')
      } catch (error) {
        console.error(error)
        this.$toast.error('Error al guardar notificaciones')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
